import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const TrelloBoardHeaderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrelloBoardHeader"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trello"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"optIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"StringValue","value":"TrelloBoard","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}},{"kind":"Field","name":{"kind":"Name","value":"enterprise"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"canInvite"}},{"kind":"Field","name":{"kind":"Name","value":"invitations"}},{"kind":"Field","name":{"kind":"Name","value":"isTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"permissionLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"premiumFeatures"}},{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"subscribed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"workspace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}}]}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"TrelloBoardHeader","document":TrelloBoardHeaderDocument}} as const;
export type TrelloBoardHeaderQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type TrelloBoardHeaderQuery = (
  { __typename: 'Query' }
  & { trello: (
    { __typename: 'TrelloQueryApi' }
    & { board?: Types.Maybe<(
      { __typename: 'TrelloBoard' }
      & Pick<Types.TrelloBoard, 'id' | 'closed' | 'objectId' | 'premiumFeatures'>
      & { enterprise?: Types.Maybe<(
        { __typename: 'TrelloEnterprise' }
        & Pick<Types.TrelloEnterprise, 'id' | 'objectId'>
      )>, prefs: (
        { __typename: 'TrelloBoardPrefs' }
        & Pick<Types.TrelloBoardPrefs, 'canInvite' | 'invitations' | 'isTemplate' | 'permissionLevel'>
      ), viewer?: Types.Maybe<(
        { __typename: 'TrelloBoardViewer' }
        & Pick<Types.TrelloBoardViewer, 'subscribed'>
      )>, workspace?: Types.Maybe<(
        { __typename: 'TrelloWorkspace' }
        & Pick<Types.TrelloWorkspace, 'id' | 'name' | 'objectId'>
      )> }
    )> }
  ) }
);

/**
 * __useTrelloBoardHeaderQuery__
 *
 * To run a query within a React component, call `useTrelloBoardHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrelloBoardHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrelloBoardHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTrelloBoardHeaderQuery(
  baseOptions: TrelloQueryHookOptions<
    TrelloBoardHeaderQuery,
    TrelloBoardHeaderQueryVariables
  > &
    (
      | { variables: TrelloBoardHeaderQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: TrelloBoardHeaderDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    TrelloBoardHeaderQuery,
    TrelloBoardHeaderQueryVariables
  >(TrelloBoardHeaderDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useTrelloBoardHeaderLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    TrelloBoardHeaderQuery,
    TrelloBoardHeaderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TrelloBoardHeaderQuery,
    TrelloBoardHeaderQueryVariables
  >(TrelloBoardHeaderDocument, options);
}
export function useTrelloBoardHeaderSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        TrelloBoardHeaderQuery,
        TrelloBoardHeaderQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TrelloBoardHeaderQuery,
    TrelloBoardHeaderQueryVariables
  >(TrelloBoardHeaderDocument, options);
}
export type TrelloBoardHeaderQueryHookResult = ReturnType<
  typeof useTrelloBoardHeaderQuery
>;
export type TrelloBoardHeaderLazyQueryHookResult = ReturnType<
  typeof useTrelloBoardHeaderLazyQuery
>;
export type TrelloBoardHeaderSuspenseQueryHookResult = ReturnType<
  typeof useTrelloBoardHeaderSuspenseQuery
>;
export type TrelloBoardHeaderQueryResult = Apollo.QueryResult<
  TrelloBoardHeaderQuery,
  TrelloBoardHeaderQueryVariables
>;
